import React, { Component } from 'react';
import {provideIntlService } from '@progress/kendo-react-intl';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

class GridDateTimeFormatter extends Component {
	constructor(props) {
		super(props);
		this.state = {

		}
	}
	formatDate = (date_string) => {
		var utc = (new Date(Date.parse(date_string))).toLocaleString('en-US', { timeZone: 'Etc/UTC' });
		return (new Date(utc).getMonth() + 1) + "/" + new Date(utc).getDate() + "/" + new Date(utc).getFullYear() + " " + ("0" + new Date(utc).getHours()).slice(-2) + ":" + ("0" + new Date(utc).getMinutes()).slice(-2) + ":" + ("0" + new Date(utc).getSeconds()).slice(-2);
	}

	render() {
		return (
			<td colSpan={this.props.colSpan} style={this.props.style}>
				{/*console.log(this.props)*/}
				{/*provideIntlService(this).formatDate(new Date(this.props.dataItem[this.props.field]), 'MM/d/y h:mm aa')*/}
				{this.formatDate(this.props.dataItem[this.props.field])}
			</td>
		);
	}
}
export default withRouter(connect(
)(GridDateTimeFormatter));